import { ALL_COOKIE_TYPES, CookieType } from "../enums/cookies";

const COOKIE_API_URL = "https://www.phase-6.de/classic/datenschutz/ajax_cookies.jsp";

function formatCookieValue(cookieSettings: CookieType[]): string {
    const uniqueSettings = Array.from(new Set(cookieSettings));
    return uniqueSettings.join("-");
}

export function isCookieType(value: any): value is CookieType {
    return ALL_COOKIE_TYPES.includes(value);
}

export function gdprCookieHasValue(searchFor: string): boolean {
    if (!isCookieType(searchFor)) {
        return false;
    }

    const cookieValue = document.cookie
        .split("; ")
        .find((item) => item.startsWith("GDPR="))
        ?.split("=")[1];

    return cookieValue?.split("-").includes(searchFor) ?? false;
}

export function setLocalCookie(cookieSettings: CookieType[]) {
    const cookieValue = formatCookieValue(cookieSettings);
    const maxAge = 31536000; // 1 year
    document.cookie = `GDPR=${cookieValue}; path=/; max-age=${maxAge};`;
}

export async function saveCookieSettingsAPI(cookieSettings: CookieType[]) {
    const cookieValue = formatCookieValue(cookieSettings);
    const response = await fetch(COOKIE_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: `GDPR=${encodeURIComponent(cookieValue)}`,
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
}
